export default "__VITE_ASSET__ec45a256__"